var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.info.is_required=='1'?'*':'')+" "+_vm._s(_vm.info.name)+" "),_c('span',{staticStyle:{"color":"#999999"}},[_vm._v("（最多支持"+_vm._s(_vm.info.max_num)+"张图片）")])]),_c('div',{staticClass:"images"},[_c('ReadyUploadSource',{attrs:{"isMany":true,"manyPath":_vm.goodsimgList,"isManyMax":_vm.info.max_num,"maxSize":1024 * 1024,"showStyle":{
              width: '98px',
              height: '98px'
          }},on:{"getSource":_vm.getImg,"changeOrder":_vm.changeOrder,"removeThis":_vm.removeImageThis}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }